// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Xeqr","footer":"ModalInfo_footer__1lYDG"};